import _ from 'lodash';
import dynamic from 'next/dynamic';

import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import SectionHPopular from 'src/components/sections/section-h-popular';
import SectionV from 'src/components/sections/section-v';
import { EMBED_ELECTION_ON_WEB, IFRAME_ELECTION, SHOW_COMMEMORATE } from 'src/constants';
import { GET } from 'src/services';
import { KEY_ADS_PAGE, KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
import { isRender } from 'src/utils/device';
import { convertObjPath, timestamp } from 'src/utils/helper';
import styled from 'styled-components';
import SectionFullH from '../section-full-h';
import SectionSpacial from '../section-event/section-spacial';
import { FiArrowRightCircle } from 'react-icons/fi';
// import HomeRecommend from '../srction-recommend/home-recommend';

const CarouselFull = dynamic(() => import('src/components/carousels/carousel-full'), { ssr: true });
const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'), { ssr: true });
const SectionHighlight = dynamic(import('src/components/sections/section-highlight'), { ssr: false });

const SectionOne = ({ data, dataLatest, dataPopular, positionAdsUpdate, sectionEventPopular, controlAds, ads, showSectionElection, sectionEventOne, sectionCommemorate, sessionSevId }) => {
  const router = useRouter();
  if (_.isEmpty(data)) return null;

  const [resData, setResData] = useState([]);
  const [resDataSectionEvnetOne, setResDataSectionEvnetOne] = useState([]);
  const [specialCommemorate, setSpecialCommemorate] = useState();

  const resEventData = {
    item1: convertDatasets(sectionEventPopular?.dataSet, 'open-close', true),
    item2: convertDatasets(sectionEventPopular?.dataSet, 'ข้อมูลที่1', true),
    item3: convertDatasets(sectionEventPopular?.dataSet, 'รูปที่1', true),
    item4: convertDatasets(sectionEventPopular?.dataSet, 'รูปโลโก้1', true)
  };

  const sectionEventOnes = {
    item1: convertDatasets(sectionEventOne?.dataSet, 'logo-img-1', true),
    item2: convertDatasets(sectionEventOne?.dataSet, 'background-img-1', true),
    item3: convertDatasets(sectionEventOne?.dataSet, 'logo-right-img-1', true),
    item4: convertDatasets(sectionEventOne?.dataSet, 'title-1', true),
    item5: convertDatasets(sectionEventOne?.dataSet, 'title-2', true),
    item6: convertDatasets(sectionEventOne?.dataSet, 'data-1', true),
    item7: convertDatasets(sectionEventOne?.dataSet, 'head-title-1', true)
  };

  useEffect(() => {
    const res = async () => {
      if (!_.isEmpty(sectionEventOne) && sectionEventOnes?.item6 !== null) {
        const result = await GET(`/api/search/tag${convertObjPath({ name: sectionEventOnes?.item6 })}&limit=2`, false, false);
        const mapResult = {
          data: result,
          title: sectionEventOnes?.item7,
          link: `/tags/${sectionEventOnes?.item6}`
        };
        setResDataSectionEvnetOne(mapResult);
      }
    };

    res();
  }, [!_.isEmpty(sectionEventOne)]);

  useEffect(() => {
    const res = async () => {
      if (!_.isEmpty(resEventData) && resEventData?.item1 === 'open') {
        const result = await GET(`/api/search/tag${convertObjPath({ name: resEventData?.item2 })}&limit=3`, false, false);
        const mapResult = {
          data: result,
          title: resEventData?.item2,
          link: `/tags/${resEventData?.item2}`
        };
        setResData(mapResult);
      }
    };

    res();
  }, []);

  // useEffect(async () => {
  //   try {
  //     if (!_.isEmpty(sectionCommemorate)) {
  //       const cateName = convertDatasets(sectionCommemorate?.dataSet, 'ชื่อแท็ก', true) || [];

  //       const data = await GET(`/api/v1.0/categories/${cateName}?limit=4`);
  //       setSpecialCommemorate(data || []);
  //     }
  //   } catch (err) {
  //     console.error(`${timestamp()} ==========> sectionCommemorate ERROR :`, err.message);
  //   }
  // }, [sectionCommemorate]);
  return (
    <>
      {controlAds === 'top' && <>{!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}</>}

      {!_.isEmpty(showSectionElection) && _.find(showSectionElection, { key: 'isShow' })?.value === 'true' && (
        <IframeWrapper id='section-iframe-election' className='section-iframe-election' src={EMBED_ELECTION_ON_WEB || IFRAME_ELECTION} width='100%' />
      )}
      {!_.isEmpty(positionAdsUpdate) && <>{controlAds !== 'top' && <>{!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}</>}</>}
      {/* {!_.isEmpty(sectionCommemorate) && !_.isEmpty(specialCommemorate) && (
          <SectionWrapper style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
            <SectionSpacial id='spacial-commemorate' data={sectionCommemorate}>
              <a className='container spacial-grid'>
                <div className='spacial-grid-list'>
                  <SectionV
                    spacial={sectionCommemorate}
                    showSpacial={false}
                    showheading={false}
                    count={4}
                    badge={false}
                    withTarget={true}
                    data={specialCommemorate}
                    heading={convertDatasets(sectionCommemorate?.dataSet, 'ชื่อแท็ก', true)}
                    path={''}
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_POSITION,
                      router: router?.pathname,
                      section: 'section-commemorate',
                      position: 'ใต้:header',
                      data: {
                        heading: convertDatasets(sectionCommemorate?.dataSet, 'ชื่อแท็ก', true)
                      }
                    }}
                  />
                </div>
              </a>
              <a href={`${convertDatasets(sectionCommemorate?.dataSet, 'link', true)}`} className='more'>
                ดูทั้งหมด <FiArrowRightCircle />
              </a>
            </SectionSpacial>
          </SectionWrapper>
      )} */}
      <div className='default-carousel-full' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <CarouselFull
          data={data?.newHighlight}
          //! DATALAYER
          eventDataLayer={{
            type: DATALAYER_TYPE.TRACK_POSITION,
            router: router?.pathname,
            section: 'section-1',
            position: 'ใต้:section-commemorate',
            data: {
              heading: 'highlight-1'
            }
          }}
        />
      </div>
      {!_.isEmpty(positionAdsUpdate) && <NoneAds></NoneAds>}
      {_.isEmpty(positionAdsUpdate) && <>{controlAds !== 'top' && <>{!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}</>}</>}
      {/* {!_.isEmpty(sessionSevId) && <HomeRecommend userId={sessionSevId} />} */}
      <SectionHighlight
        data={data?.newHighlight2}
        // electionUpdate= {usElectionLink?.updated_at}
        // usElectionLink={usElectionLink?.dataSet}
        sectionEventOne={resDataSectionEvnetOne}
        sectionEventOneItem={sectionEventOnes}
        //! DATALAYER
        eventDataLayer={{
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router?.pathname,
          section: 'section-us',
          position: 'ใต้:โฆษณาตำแหน่ง billboard',
          data: {
            heading: 'highlight-2'
          }
        }}
      />
      {/* ---------------------------- ADS PPN : INARTICLE_1 --------------------------- */}
      {isRender('mobile') && <DynamicAds page={KEY_ADS_PAGE.HOMEPAGE} position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}

      <section id='section-3' className='container default-section' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row'>
          <div className='col-12 col-lg-8'>
            {!_.isEmpty(dataLatest?.data) && (
              <SectionV
                data={dataLatest?.data}
                count={6}
                heading='ข่าวล่าสุด'
                badge={false}
                path='/category/latest-news'
                sectionCol='col-lg-4 col-md-6 col-6'
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-3',
                  position: 'ใต้:section-2',
                  data: {
                    block: '1',
                    heading: 'ข่าวล่าสุด'
                  }
                }}
              />
            )}
          </div>
          {!_.isEmpty(resData) ? (
            <div className='col-12 col-lg-4 bkk-wrapper-section-event' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
              <SectionEventBKK className='bkk-section-event' backgroundEv={resEventData?.item3}>
                <div className='bkk-section-event-img'>
                  <img src={`${resEventData?.item4}`} alt={`${resEventData?.item2}`} />
                </div>
                <SectionFullH
                  data={resData}
                  count={3}
                  path={resData.link}
                  heading={resData.title}
                  //! DATALAYER
                  eventDataLayer={{
                    type: DATALAYER_TYPE.TRACK_POSITION,
                    router: router?.pathname,
                    section: 'section-3',
                    position: 'ใต้:section-2',
                    data: {
                      block: '2',
                      heading: resData.title
                    }
                  }}
                />
              </SectionEventBKK>
            </div>
          ) : (
            <div className='col-12 col-lg-4 section-popular' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
              {!_.isEmpty(dataPopular?.data) && (
                <SectionHPopular
                  data={dataPopular.data}
                  count={5}
                  heading='ข่าวยอดนิยม'
                  //! DATALAYER
                  eventDataLayer={{
                    type: DATALAYER_TYPE.TRACK_POSITION,
                    router: router?.pathname,
                    section: 'section-3',
                    position: 'ใต้:section-2',
                    data: {
                      block: '2',
                      heading: 'ข่าวยอดนิยม'
                    }
                  }}
                />
              )}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SectionOne;
const IframeWrapper = styled.iframe`
  height: 900px;
  border: unset;
  margin-top: 20px;
`;
const NoneAds = styled.div`
  padding: 15px 0 !important;
`;
const SectionEventBKK = styled.div`
  &.bkk-section-event {
    background: ${props => `url(${props?.backgroundEv})`};
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 15px;
    @media (max-width: 768px) {
      margin-bottom: 0;
      border-radius: 0;
    }
    .bkk-section-event-img {
      display: flex;
      justify-content: center;
      img {
        margin-top: -15px;
        width: 100%;
        max-width: 350px;
        height: 100%;
      }
    }

    .block-title {
      border-bottom: unset;
      justify-content: end;
      margin-bottom: 10px;
      h2 {
        display: none;
      }
      a {
        color: #fff;
        &:hover {
          svg {
            color: #0600e7;
          }
        }
        svg {
          color: #fff;
        }
      }
    }
    .block-wrapper {
      background-color: #5a5a5aa6;
      border-radius: 5px;
      margin-bottom: 0;
      padding: 10px;
      margin-top: -15px;
      .block-list {
        li {
          &:nth-last-child(1) {
            margin-bottom: 0;
          }
        }
        .card-h-content {
          h3 {
            color: #fff;
          }
        }
        .card-h-content-meta {
          svg,
          span {
            color: #ffffffc1;
          }
        }
      }
    }
  }
`;
const SectionWrapper = styled.div`
    #spacial-commemorate {
      position: relative;
      .spacial-grid {
        padding: 12rem 1rem 2rem !important;
        @media (max-width: 1024px) {
          padding: 10rem 1rem 0rem !important;
        }
      }
        .card-v-content-meta {
        margin-top: 5px;
        }
        .card-v-thumb {
            margin-bottom: 10px;
        }
      .more {
        color: #fff;
        position: absolute;
        bottom: 20px;
        right: 30px;
        :hover {
          color: #ffffff92;
        }
      }
    }
    #spacial-commemorate,
    #spacial-war {
      background-position: center;
      @media (min-width: 767px) and (max-width: 1024px) {
        background-size: contain;
        background-position: top center;
        background-color: white;
      }

      .spacial-grid {
        padding: 20rem 1rem 2rem;
        @media (max-width: 1024px) {
          padding: 11rem 1rem 0rem;
        }
      }
      .spacial-card {
        border-radius: 8px;
      }
      .spacial-grid-list .row {
        grid-gap: 20px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        @media (max-width: 1024px) {
          grid-template-columns: 1fr 1fr;
          grid-template-areas: '--item-1 --item-2' '--item-3 --item-4';
        }
      }
    }
  }
`;
